export const formFields = {
    username: {
        key: 'username',
        type: 'text',
        label: 'Full Name',
        required: true,
        placeholder: 'Enter Full Name',
        requiredMessage: 'Full Name is required',
        displayLayout: 'col-sm-12',
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        pattern: /^(?![\s\S]*<[^>]*>).+$/
    },
    email: {
        key: 'email',
        type: 'text',
        label: 'Email',
        required: true,
        placeholder: 'Enter Email',
        requiredMessage: 'Email is required',
        displayLayout: 'col-sm-12',
        maxLength: 50,
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        patternMessage: 'Please enter a valid Email',
        maxLengthMessage: 'maximum 50 characters allowed.',
        spaceNotAllowed: true,
    },
    companyName: {
        key: 'companyName',
        type: 'text',
        label: 'Company Name',
        required: false,
        placeholder: 'Enter Company Name',
        requiredMessage: 'Company Name is required',
        displayLayout: 'col-sm-12',
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },
    accountName: {
        key: 'accountName',
        type: 'text',
        label: 'Account Name',
        required: true,
        placeholder: 'Enter Account Name',
        requiredMessage: 'Account Name is required',
        displayLayout: 'col-sm-12',
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        pattern: /^(?![\s\S]*<[^>]*>).+$/
    },
    tenantTypeId: {
        key: 'tenantTypeId',
        label: 'Business Type ',
        placeholder: '',
        required: true,
        requiredMessage: 'Business Type  is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Tenant Type </div>',
        valueKey: 'id',
        textKey: 'text',
        options: [{ id: 5, text: "Advertiser" },
        { id: 1138, text: "Agency" },
        // { id: 1140, text: "Advertiser & Agency" },
        ]

    },

    country: {
      key: 'country',
      label: 'Country',
      required: true,
      placeholder: '',
      displayLayout: 'col-md-12',
      requiredMessage: 'This field is required.',
      tooltip: '<div> Country </div>',
      valueKey: 'countryName',
      addModel: false,
      textKey: 'countryName',
      valueKey: 'id',
      textKey: 'value',
      // maxLength: 50,
      // maxLengthMessage: 'maximum 50 characters allowed.',
    },

    timezone: {
        key: 'timezone',
        label: 'Timezone',
        required: true,
        placeholder: '',
        displayLayout: 'col-md-12',
        requiredMessage: 'This field is required.',
        tooltip: '<div> Timezone </div>',
        valueKey: 'key',
        addModel: false,
        textKey: 'value',
        valueKey: 'key',
        textKey: 'value',
        // maxLength: 50,
        // maxLengthMessage: 'maximum 50 characters allowed.',
      },

    currency: {
      key: 'currency',
      label: 'Currency',
      required: true,
      placeholder: '',
      displayLayout: 'col-md-12',
      requiredMessage: 'This field is required.',
      tooltip: '<div> Currency </div>',
      addModel: false,
      valueKey: 'id',
      textKey: 'value',
      // maxLength: 50,
      // maxLengthMessage: 'maximum 50 characters allowed.',
    },



    // contact: {
    //     key: 'contact',
    //     type: 'number',
    //     label: 'Phone',
    //     required: true,
    //     placeholder: 'Enter Phone Number',
    //     requiredMessage: 'Phone Number is required.',
    //     displayLayout: 'col-md-12',
    //     // pattern: /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/,
    //     pattern: /^\d{7,14}(?:,\d{7,14})*$/,
    //     patternMessage: 'Minimum 7 and Maximum 14 Digit allowed'


    //     // patternMessage: 'Please enter a valid Phone no.'
    // },
};


export const confirmationMessage = {
    action: {
        confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
        type: 'Confirmation'
    }
}